// @flow
import { PRODUCT_SPACE_INTRODUCTION } from 'Client/cms/toolkit/constants';
import { ProductSpaceIntroductionLine } from 'Components/lines/product-space-introduction-line/ProductSpaceIntroductionLine.jsx';
import { productSpaceIntroductionResolver } from './productSpaceIntroduction.resolver';

export const productSpaceIntroductionDescriptor = {
  name: PRODUCT_SPACE_INTRODUCTION,
  component: ProductSpaceIntroductionLine,
  resolver: productSpaceIntroductionResolver.resolve,
};
